angular.module 'zc.projects'

.controller 'CampaignPolicySetCtrl', ($scope, $stateParams, $window, CampaignPolicySet, Api) ->
  $scope.campaignPolicySets = []
  $scope.campaignPolicySet =
    name: ''
    description: ''

  CampaignPolicySet.all({projectId: $stateParams.projectId}).then (campaignPolicySets) ->
    $scope.campaignPolicySets = campaignPolicySets

  $scope.removeCampaignPolicySet = (id) ->
    CampaignPolicySet.destroy
      projectId: $stateParams.projectId
      id: id
    .then () ->
      $scope.campaignPolicySets = _.reject $scope.campaignPolicySets, (set) -> set.id is id

  $scope.downloadCampaignPolicySet = (id) ->
    endpoint = "/api/projects/#{$stateParams.projectId}/campaign_policy_sets/#{id}.csv"
    url = Api.path(endpoint)
    $window.location = url

  $scope.campaignPolicySetUploadUrl = "/api/projects/#{$stateParams.projectId}/campaign_policy_sets"
  $scope.$on 'flow::fileAdded', (event, $flow, flowFile) ->
    event.preventDefault()
    $scope.campaignPolicySet.name or= flowFile.name[0...-('.csv'.length)]

    CampaignPolicySet.create
      projectId: $stateParams.projectId
    ,
      file: flowFile.file
      name: $scope.campaignPolicySet.name
      description: $scope.campaignPolicySet.description
    .then (campaignPolicySet) ->
      $scope.campaignPolicySets.push(campaignPolicySet)
      $scope.campaignPolicySet =
        name: ''
        description: ''



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.settings/campaign/campaign_policy_set.controller.coffee